"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var DEFAULT_CONFIGS = { locale: 'en', short: false, fallback: '' };
// In any situation when we are echoing the guest's name,
// we want to use the alternative names (e.g. Japanese) if we have it.
// This function returns the guest's full name considering the order by locale
function getGuestDisplayName(guest, configsWithoutDefault) {
    var _a, _b, _c, _d;
    // Merge passed in configs with default
    var configs = __assign(__assign({}, DEFAULT_CONFIGS), configsWithoutDefault);
    var first = (_a = guest === null || guest === void 0 ? void 0 : guest.firstName) !== null && _a !== void 0 ? _a : '';
    var last = (_b = guest === null || guest === void 0 ? void 0 : guest.surname) !== null && _b !== void 0 ? _b : '';
    var altFirst = (_c = guest === null || guest === void 0 ? void 0 : guest.alternativeFirstName) !== null && _c !== void 0 ? _c : '';
    var altLast = (_d = guest === null || guest === void 0 ? void 0 : guest.alternativeSurname) !== null && _d !== void 0 ? _d : '';
    // Prefer alt names. Do not allow empty strings as values
    var displayFirst = (altFirst !== '' && altFirst) || (first !== '' && first);
    var displayLast = (altLast !== '' && altLast) || (last !== '' && last);
    if (!displayFirst && !displayLast) {
        return configs.fallback;
    }
    var names = [];
    // Order changes for japanese
    var insert = configs.locale === 'ja' ? 'unshift' : 'push';
    if (displayFirst) {
        names[insert](displayFirst.trim());
    }
    if (displayLast) {
        names[insert](displayLast.trim());
    }
    // show short name or fallback
    if (configs.short) {
        return names.shift() || configs.fallback;
    }
    // Only show full name if both names exist
    return names.join(' ') || configs.fallback;
}
exports.default = getGuestDisplayName;
